






























































































































































































import Ueditor from "@/components/Ueditor/index.vue";
import {Component, Ref, Vue} from "vue-property-decorator";
import api from "@/api";
import Tinymce from "@/components/Tinymce/index.vue";
import {
  AttachmentHostType,
  DataDictionaryDtoPagedResultDto,
  FundDto,
  FundDtoPagedResultDto,
  FundProjectApplyCreateOrUpdateDto,
} from "@/api/appService";
import {ElForm} from "element-ui/types/form";
import AbSelect from "@/components/AbSelect/index.vue";
import MultipleUploadFile from "@/components/MultipleUploadFile/index.vue";
import SimpleUploadImage from "@/components/SimpleUploadImage/index.vue";

@Component({
  components: {
    Tinymce,
    AbSelect,
    Ueditor,
    MultipleUploadFile,
    SimpleUploadImage,
  },
})
export default class CreateFundMaintain extends Vue {
  @Ref() readonly dataForm!: ElForm;
  dataId?:number = 0;
  form: FundProjectApplyCreateOrUpdateDto = {};
  radio: string = "";
  typeList: any = [];
  honorTypeList: any = [];
  checkList: any = [];
  projectRange: any = [];
  sex = "";
  yesOrNoList = [
    {
      key: "是",
      value: true,
    },
    {
      key: "否",
      value: false,
    },
  ];
  fundList: FundDto[] = [];
  btnDisabled: boolean = false;

  get hostTypeFile() {
    return AttachmentHostType.FundProjectApply;
  }

  created() {
    this.fetchEnumType();
    this.fetchDataDictionary();
    this.fetchFundList();
  }

  async fetchEnumType() {
    await api.enumService
      .getValues({
        typeName: "FundProjectType",
      })
      .then((res) => {
        this.typeList = res;
      });
  }

  async fetchDataDictionary() {
    await api.dataDictionary
      .getDataDictionaryListByKey({key: "HonorType", maxResultCount: 1000})
      .then((res: DataDictionaryDtoPagedResultDto) => {
        this.honorTypeList = res.items;
      });
    await api.dataDictionary
      .getDataDictionaryListByKey({key: "ProjectRange", maxResultCount: 1000})
      .then((res: DataDictionaryDtoPagedResultDto) => {
        this.projectRange = res.items;
      });
  }

  async fetchFundList() {
    await api.fund.getAll({maxResultCount: 100000}).then((res: FundDtoPagedResultDto) => {
      this.fundList = res.items ?? [];
    });
  }

  async save() {
    this.btnDisabled = true;
    (this.$refs.dataForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.checkList) {
          this.form.categoryName = this.checkList.join(",");
        }
        await api.fundProjectApply.create({
          body: this.form,
        }).catch(() => {
          this.btnDisabled = false;
        });
        this.$router.back();
        this.$message.success("新增成功");
      } else {
        this.$message.error("请检查表单");
        this.btnDisabled = false;
      }
    });
  }

  cancel() {
    this.$router.back();
    // (this.$refs.dataForm as any).resetFields();
    // this.$emit("input", false);
  }

  roleRule = {
    name: [
      {
        required: true,
        message: "项目名称必填",
        trigger: "blur",
      },
    ],
    fundID: [
      {
        required: false,
        message: "所属基金必填",
        trigger: "blur",
      },
    ],
    projectType: [
      {
        required: true,
        message: "项目类型必填",
        trigger: "blur",
      },
    ],
    startTime: [
      {
        required: true,
        message: "开始时间必填",
        trigger: "blur",
      },
    ],
    description: [
      {
        required: true,
        message: "项目详情必填",
        trigger: "blur",
      },
    ],
    contactsEmail: [
      {
        message: "请填写正确的邮箱地址",
        type: "email",
        trigger: "blur",
      },
    ],
  };
}
